<script>
  import { isMobile } from 'mobile-device-detect'
  import bus from '@/utils/eventBus'
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'message',
    data: function () {
      return {
        showMessages: false,
        isMobiled: false,
        occurrence_id: null,
        messages: [],
        message: {
          content: null,
          dweller_book_occurrence_id: null
        }
      }
    },
    methods: {
      doSend () {
        const params = {
          content: this.message.content,
          dweller_book_occurrence_id: this.occurrence_id
        }
        this.$http.post('/v1/dweller/occurrence/messages', params)
          .then(({data}) => {
            this.getOccurrenceMessages(this.occurrence_id)
          }).catch(({data}) => {
            this.errors = data
          })
      },
      doHideMessage () {
        this.showMessages = false
      },
      formatTime (time) {
        return moment(time).format('HH:mm')
      },
      formatDate (dt) {
        return moment(dt).format('DD/MM/YYYY')
      },
      getOccurrenceMessages (occurrenceId) {
        this.$http.get('/v1/dweller/occurrence/messages/' + occurrenceId)
          .then(({data}) => {
            this.messages = data
            this.occurrence_id = occurrenceId
            this.message.content = null
            // window.scrollTo({ bottom: 0, behavior: 'smooth' })
            // window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
          })
      }
    },
    mounted () {
      bus.$on('show-message-occurrence', values => {
        this.showMessages = values.show
        this.getOccurrenceMessages(values.occurrence)
      })
      if (isMobile) {
        this.isMobiled = true
      }
    },
    computed: {
      ...mapGetters(['user'])
    }
  }
</script>

<template lang="pug">
  .modal-backdrop(v-if="showMessages")
    .modal(
      style='z-index: 1040; padding-right: 15px; display: block;',
      aria-modal='true',
      v-show="showMessages"
      :class="{'modal-mobile': isMobiled}"
    )

      .modal-dialog(role='document')
        .modal-content
          .modal-header
            h4#defaultModalLabel.title
          .modal-body
                .body
                  ul.chat-widget.m-r-5.clearfix(style="height:300px; overflow:auto;")
                    li(v-for="(message, idx) in messages", :key="idx", :class="{'right': user.id === message.user_id, 'left float-left': user.id !== message.user_id}")
                      img.rounded-circle(
                        :src='message.user.image.url', alt='',
                        v-if="message.user.image.url !== null && user.id !== message.user_id"
                      )
                      .chat-info
                        span.datetime(v-if="user.id !== message.user_id") {{ message.user.name }} {{formatDate(messages.created_at)}} {{formatTime(messages.created_at)}}
                        span.datetime(v-if="user.id === message.user_id") {{formatDate(messages.created_at)}} {{formatTime(messages.created_at)}}
                        span.message(style="text-align: justify;")
                          | {{ message.content }}

                  .input-group.p-t-15
                    input.form-control(
                      type='text',
                        v-model="message.content"
                      )
                    span.input-group-addon.cursor-pointer(@click.prevent="doSend()")
                      i.zmdi.zmdi-mail-send

          .modal-footer
            button.btn.btn-simple.btn-icon.btn-icon-mini.btn-round(style="float: right;", @click.prevent="doHideMessage")
                i.zmdi.zmdi-close
</template>
<style scoped>
  .size-100 {
    width: 100%;
  }
  .modal-body {
      min-height: 300px;
      overflow-y: auto;
  }
  .modal-mobile {
      position: fixed;
      top: 0;
      right: -17px;
      bottom: 0;
      left: 36px;
      z-index: 1050;
      display: none;
      overflow: hidden;
      outline: 0;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  </style>



// WEBPACK FOOTER //
// src/app/dweller/book-occurrence/index/components/message.vue